import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Wordmark } from "@/components/Header";
import { PetitionCTA } from "@/components/PetitionCTA";

const NotFound = () => (
  <div className="flex min-h-screen flex-col bg-gooi-offwhite">
    <header className="border-b border-gooi-green/10">
      <div className="mx-auto max-w-[90rem] px-5 py-5 md:px-12">
        <Wordmark />
      </div>
    </header>
    <main
      data-testid="not-found-page"
      className="mx-auto flex w-full max-w-[90rem] flex-1 flex-col justify-center px-5 py-24 md:px-12"
    >
      <p className="font-display text-sm font-semibold uppercase tracking-[0.25em] text-gooi-red">404</p>
      <h1 className="mt-4 max-w-2xl font-display text-4xl font-medium leading-tight tracking-tighter text-gooi-green md:text-6xl">
        Deze afslag bestaat niet.
      </h1>
      <p className="mt-5 max-w-xl text-base leading-relaxed text-gooi-green/70 md:text-lg">
        Geen probleem — met één minuut extra ben je weer op de goede weg.
      </p>
      <div className="mt-9 flex flex-wrap items-center gap-5">
        <PetitionCTA location="notfound" size="md" />
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-gooi-green/80 transition-colors duration-300 hover:text-gooi-green"
        >
          <ArrowLeft className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" />
          Terug naar de homepage
        </Link>
      </div>
    </main>
  </div>
);

export default NotFound;
